module.exports = __webpack_public_path__ + "static/media/ailesbury.f41f20ae.png";